import { Mail, Phone, Instagram, Twitter } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
    return (
        <footer className="mt-24 bg-rk-navy text-white">
            <div className="rk-divider-gold" />
            <div className="max-w-[1400px] mx-auto px-4 md:px-8 lg:px-12 py-16 grid grid-cols-2 md:grid-cols-6 gap-10">
                <div className="col-span-2">
                    <Logo variant="light" />
                    <p className="text-sm text-white/70 max-w-sm leading-relaxed mt-5">
                        India's most luxurious rewards marketplace. Instant digital gift cards
                        from 270+ curated brands — delivered in 10 seconds via WhatsApp or email.
                    </p>
                    <p className="mt-4 font-serif italic text-rk-gold/90 text-lg">खुशियाँ भेजो.</p>
                </div>

                <div>
                    <h4 className="text-[10px] uppercase tracking-[0.28em] text-rk-gold mb-5">Explore</h4>
                    <ul className="space-y-3 text-sm text-white/80">
                        <li><Link to="/catalog" className="rk-link-gold">All Brands</Link></li>
                        <li><Link to="/catalog?featured=true" className="rk-link-gold">Featured</Link></li>
                        <li><Link to="/gifts/birthday" className="rk-link-gold">Birthday Gifts</Link></li>
                        <li><Link to="/gifts/anniversary" className="rk-link-gold">Anniversary</Link></li>
                        <li><Link to="/gifts/diwali" className="rk-link-gold">Diwali Edit</Link></li>
                        <li><Link to="/blog" className="rk-link-gold">Gifting Journal</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-[10px] uppercase tracking-[0.28em] text-rk-gold mb-5">Categories</h4>
                    <ul className="space-y-3 text-sm text-white/80">
                        <li><Link to="/catalog?category=Jewellery" className="rk-link-gold">Jewellery</Link></li>
                        <li><Link to="/catalog?category=Travel" className="rk-link-gold">Travel</Link></li>
                        <li><Link to="/catalog?category=Hotels" className="rk-link-gold">Hotels</Link></li>
                        <li><Link to="/catalog?category=Electronics" className="rk-link-gold">Electronics</Link></li>
                        <li><Link to="/catalog?category=Food+%26+Beverage" className="rk-link-gold">F&B</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-[10px] uppercase tracking-[0.28em] text-rk-gold mb-5">Company</h4>
                    <ul className="space-y-3 text-sm text-white/80">
                        <li><Link to="/about" className="rk-link-gold">About</Link></li>
                        <li><Link to="/how-it-works" className="rk-link-gold">How it works</Link></li>
                        <li><Link to="/faqs" className="rk-link-gold">FAQs</Link></li>
                        <li><Link to="/contact" className="rk-link-gold">Contact</Link></li>
                        <li className="pt-1 text-[10px] uppercase tracking-[0.24em] text-white/40">Legal</li>
                        <li><Link to="/terms" className="rk-link-gold">Terms</Link></li>
                        <li><Link to="/privacy" className="rk-link-gold">Privacy</Link></li>
                        <li><Link to="/refund-policy" className="rk-link-gold">Refunds</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-[10px] uppercase tracking-[0.28em] text-rk-gold mb-5">Connect</h4>
                    <ul className="space-y-3 text-sm text-white/80">
                        <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-rk-gold" /> hello@loyltykart.in</li>
                        <li className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-rk-gold" /> 1800-123-4567</li>
                        <li className="flex items-center gap-3 pt-2">
                            <Instagram className="w-4 h-4 hover:text-rk-gold cursor-pointer" />
                            <Twitter className="w-4 h-4 hover:text-rk-gold cursor-pointer" />
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10 py-5 text-center text-[11px] tracking-wider text-white/50">
                © 2026 LoyltyKart · All brand names are trademarks of their respective owners.
            </div>
        </footer>
    );
}
